import { render, staticRenderFns } from "./home-score.vue?vue&type=template&id=65080bc4&scoped=true&"
import script from "./home-score.vue?vue&type=script&lang=ts&"
export * from "./home-score.vue?vue&type=script&lang=ts&"
import style0 from "./home-score.vue?vue&type=style&index=0&id=65080bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65080bc4",
  null
  
)

export default component.exports